module.exports = __webpack_public_path__ + "img/SEJ_Eventos_detalles-gris.45fd0d90.svg";